import React from 'react';
import classnames from 'classnames';

import "./scrapbook.scss";
import { ScrapbookStore } from '../../store/ScrapbookStore';
import Loading from '../../../ts/components/common/Loading';
import { ScrapbookShard } from '../scrapbookShard/ScrapbookShard';
import { ScrapNotebook } from '../scrapNotebook/ScrapNotebook';
import { ScrapbookTitle } from '../scrapbookTitle/ScrapbookTitle';
import { ScrapbookShareButton } from '../scrapbookShareButton/ScrapbookShareButton';
import { ScrapbookExportButton } from '../scrapbookExportButton/ScrapbookExportButton';

export interface IProps {
    store: ScrapbookStore;
}
export interface IState {
    isDisplayingAllShards: boolean;
}

export class Scrapbook extends React.Component <IProps, IState> {
    private hasBeenMounted: boolean;
    private root: HTMLElement;
    
    constructor(props: IProps) {
        super(props);

        this.handleStateChange = this.handleStateChange.bind(this);
        this.onNewNotebookClick = this.onNewNotebookClick.bind(this);
        this.onSearchKeyDown = this.onSearchKeyDown.bind(this);
        this.onSearchChange = this.onSearchChange.bind(this);
        this.cancelSearch = this.cancelSearch.bind(this);
        this.handleRef = this.handleRef.bind(this);
        this.onShowAllClick = this.onShowAllClick.bind(this);

        this.props.store.onChange(this.handleStateChange);

        this.state = {
            isDisplayingAllShards: false
        };
    }

    public componentDidMount(){
        this.hasBeenMounted = true;
    }

    public componentWillUnmount(){
        this.hasBeenMounted = false;
    }

    private handleStateChange(){
        this.hasBeenMounted && this.forceUpdate();
    }

    public render(){
        const store = this.props.store;
        const state = store.state;
        if(!state.isShown) { return null; }
        
        return <div className="scrapbook-root" ref={this.handleRef}>
                    <div className="_content">
                        <div className="_left-column">
                            <div className="_left-column-header">
                                <div className="_left-column-row">
                                    <h4>notebooks</h4>
                                    { this.renderAddNotebookButton()}
                                </div>
                                <div className="_left-column-search-row">
                                    <i className="fa fa-search _search-icon"/>
                                    <input type="text" className="scrapbook-search-input" 
                                                       placeholder="search notebooks" 
                                                       onKeyDown={this.onSearchKeyDown}
                                                       onChange={this.onSearchChange}/>
                                    <i className="fa fa-times _delete-search-icon" onClick={this.cancelSearch}/>
                                </div>
                            </div>
                            <div className="_left-column-content">
                                { this.generateLeftColumnContent() }
                            </div>
                        </div>
                        <div className={classnames("_right-column", {"_has-content": this.rightColumnHasContent()})}>
                            { this.generateRightColumnContent() }
                        </div>
                    </div>

                    <button className="_close-button" onClick={this.props.store.toggleShown}>
                        <i className="fa fa-times"></i>
                    </button>
                    { this.renderWholeContentLoadingIfNecessary()}
               </div>
    }

    private renderAddNotebookButton(){
        if(this.props.store.isShowingSearchContent()){
            return null;
        }
        
        return <button onClick={this.onNewNotebookClick}>
                    <svg width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.23525 2.11765C2.23525 1.53287 2.7093 1.05882 3.29407 1.05882H16.3529C16.9377 1.05882 17.4117 1.53288 17.4117 2.11765V18.8824C17.4117 19.4671 16.9377 19.9412 16.3529 19.9412H3.29407C2.7093 19.9412 2.23525 19.4671 2.23525 18.8824V2.11765Z" stroke="#828282" strokeWidth="2.11765"/>
                        <line x1="0.992647" y1="5.18387" x2="4.88971" y2="5.18387" stroke="#828282" strokeWidth="1.98529" strokeLinecap="round"/>
                        <line x1="0.992647" y1="8.71316" x2="4.88971" y2="8.71316" stroke="#828282" strokeWidth="1.98529" strokeLinecap="round"/>
                        <line x1="0.992647" y1="12.2427" x2="4.88971" y2="12.2427" stroke="#828282" strokeWidth="1.98529" strokeLinecap="round"/>
                        <line x1="0.992647" y1="15.772" x2="4.88971" y2="15.772" stroke="#828282" strokeWidth="1.98529" strokeLinecap="round"/>
                        <rect width="11" height="11" transform="translate(8 10)" fill="white"/>
                        <path d="M12.125 10H14.875V14.125H19V16.875H14.875V21H12.125V16.875H8V14.125H12.125V10Z" fill="#828282"/>
                    </svg>
                </button> 
    }

    private renderWholeContentLoadingIfNecessary(){
        if(this.props.store.state.isLoading){
            return <Loading/>;
        }

        if(this.props.store.isShowingSearchContent() && this.props.store.searchState.isLoading){
            return <Loading/>;
        }
        
        return null;
    }

    private generateLeftColumnContent(){
        const allShards = this.props.store.getActiveScrapbookShards() || []
        let displayedShards = allShards;

        if(displayedShards.length > 10 && !this.state.isDisplayingAllShards){
            displayedShards = displayedShards.slice(0, 10);
        }

        return <>
                    { displayedShards.map(shard => <ScrapbookShard key={shard.id} 
                                                                shard={shard} 
                                                                store={this.props.store}
                                                                isSelected={this.props.store.isSelectedShard(shard)} 
                                                                onClick={() => this.props.store.selectScrapbookShard(shard.id)}/>)}
                    { displayedShards.length != allShards.length ? 
                        <div className="_centered-container">
                            <button onClick={this.onShowAllClick}>show all</button>
                        </div> 
                        : null
                    }
               </>

        return 
    }

    private rightColumnHasContent(): boolean {
        if(this.props.store.hasSearchError()
        || this.props.store.hasntFoundAnySearchResults()) { return true; }

        if(this.props.store.isLoading() || !this.props.store.hasSelectedShard()
        || this.props.store.isLoadingScrapbook()) { return false; }

        return true;
    }

    private generateRightColumnContent(){
        if(this.props.store.hasSearchError()){
            return <div className="scrapbook-message _error-message">
                    { this.props.store.searchState.errorMessage}
                   </div>
        }

        if(this.props.store.hasntFoundAnySearchResults()){
            return <div className="scrapbook-message">
                     Unfortunately, we weren't able to find any results. Try something else?
                   </div>
        }
        
        if(this.props.store.isLoading()) { return null; } 
        if(!this.props.store.hasSelectedShard()){
            if(this.props.store.state.scrapbookShards == null 
            || this.props.store.state.scrapbookShards.length == 0) {
                return <div className="scrapbook-message _action-message" onClick={this.props.store.requestTour}>
                            <div className="_message-title">your notebook</div>
                            <div className="_message-footer">explore how <i className="fa fa-caret-right"></i></div>
                       </div>
            }
            else {
                return null;
            }
        }
        
        if(this.props.store.isLoadingScrapbook()) {
            return <Loading/>;
        }

        return <>
                 <div className="scrapbook-header">
                    <ScrapbookTitle store={this.props.store} scrapbook={this.props.store.getSelectedScrapbook()}/>
                    {this.renderCommandsContainer()}
                 </div>
                 <ScrapNotebook store={this.props.store} 
                                scrapbook={this.props.store.getSelectedScrapbook()}
                                disableDrag={this.props.store.isShowingSearchContent()}
                                openLinkInNewTab={true}/>
               </>
    }

    private renderCommandsContainer(){
        if(this.props.store.isShowingSearchContent()) { return null; }
        return <div className="_commands-container">
                    <ScrapbookShareButton key={`${this.props.store.state.selectedScrapbook != null ? this.props.store.state.selectedScrapbook.id : "-1"}-share`} 
                                          scrapbook={this.props.store.state.selectedScrapbook}
                                          store={this.props.store}
                                          width={24} height={30}/>
                    <div className="_separator"></div>
                    <ScrapbookExportButton key={`${this.props.store.state.selectedScrapbook != null ? this.props.store.state.selectedScrapbook.id : "-1"}-export`} 
                                           scrapbook={this.props.store.state.selectedScrapbook}
                                           store={this.props.store}/>
                </div>
    }

    private onNewNotebookClick(){
        this.props.store.createNewNotebook();
    }

    private onSearchKeyDown(e) {
        const keyCode = e.keyCode || e.which;
        if(keyCode == 13) { //Enter
            const text = e.target.value;
            if(text.trim()){
                this.props.store.search(text);
            }
        }
        else if(keyCode == 27){ //Esc
            this.cancelSearch();
        }
    }

    private onSearchChange(e){
        this.updateCancelSearchIcon(e.target);
    }

    private cancelSearch(){
        const searchInput = this.getSearchInput();
        if(searchInput != null){
            searchInput.value = "";
            this.updateCancelSearchIcon(searchInput);
        }
        
        this.props.store.cancelSearch();
    }

    private handleRef(root: HTMLElement){
        this.root = root;
    }

    private getSearchInput(): HTMLInputElement {
        if(this.root == null) { return null; }

        return this.root.querySelector(".scrapbook-search-input");
    }

    private updateCancelSearchIcon(searchInput: HTMLInputElement){
        const deleteIcon = searchInput.parentElement.querySelector("._delete-search-icon");
        if(searchInput.value){
            deleteIcon.classList.add("_shown");
        }
        else {
            deleteIcon.classList.remove("_shown");
        }
    }

    private onShowAllClick(){
        this.setState({
            isDisplayingAllShards: true
        });
    }
}